<template>
    <div class="header-okr">
        <el-button
            @click="isCreate = true"
            type="primary"
            style="background: #472F92; border: none"
        >
            <i class="el-icon-plus"></i> Thêm mới OKR
        </el-button>
        <el-dialog
            class="responsive" v-if="isCreate" width="40%" :show-close="false"
            :visible.sync="isCreate" :close-on-click-modal="false"
            append-to-body title="Thêm mới OKR" destroy-on-close
        >
            <hr style="margin-top: -20px; border: 1px solid lightgray"/>
            <FormOKR @closeDialog="isCreate = false" @getListOkr="getListOkr"/>
        </el-dialog>
    </div>
</template>

<script>
import FormOKR from "@/views/pages/manage-okrs/component/FormOKR.vue";

export default {
    name: 'HeaderOKR',
    components: {FormOKR},
    data() {
        return {
            isCreate: false
        }
    },
    methods: {
        getListOkr() {
            this.$emit('getListOkr')
        }
    }
}
</script>

<style scoped>
.header-okr {
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
    align-items: center;
}
</style>
